'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { getCountryByCode } from '@/lib/data-source';
import { getSlugForCountry } from '@/lib/i18n';
import { detectBrowserLang } from '@/hooks/useAutoCountry';
import type { CountryCode } from '@/lib/types';

export function CountryRedirect({ code }: { code: string }) {
  const router = useRouter();

  useEffect(() => {
    const normalizedCode = code.toUpperCase() as CountryCode;
    const country = getCountryByCode(normalizedCode);

    if (!country) {
      router.replace('/');
      return;
    }

    const lang = detectBrowserLang();
    const slug = getSlugForCountry(normalizedCode, lang);
    router.replace(`/${slug}`);
  }, [code, router]);

  return null;
}
